var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_security") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-77, -273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5,277 L102.487171,280.329057 C102.793427,280.431142 103,280.717747 103,281.040569 C103,283.527046 103,286.013523 103,288.5 C103,290.213214 102.453913,291.951821 101.361738,293.715821 L99.2938926,292.213525 C99.1186489,292.086203 98.8813511,292.086203 98.7061074,292.213525 L95.4896666,294.550407 C95.3144229,294.677729 95.2410938,294.903412 95.3080309,295.109424 L96.536602,298.890576 C96.5465469,298.921184 96.559252,298.950323 96.5743878,298.977754 C95.3827263,299.976956 94.0243505,300.984619 92.5,302 C85.5,297.333333 82,292.833333 82,288.5 L82,281.040569 C82,280.717747 82.2065726,280.431142 82.5128292,280.329057 L92.5,277 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#0E1C39",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2938926,292.213525 L102.510333,294.550407 C102.685577,294.677729 102.758906,294.903412 102.691969,295.109424 L101.463398,298.890576 C101.396461,299.096588 101.204483,299.236068 100.98787,299.236068 L97.0121303,299.236068 C96.7955171,299.236068 96.6035391,299.096588 96.536602,298.890576 L95.3080309,295.109424 C95.2410938,294.903412 95.3144229,294.677729 95.4896666,294.550407 L98.7061074,292.213525 C98.8813511,292.086203 99.1186489,292.086203 99.2938926,292.213525 Z",
    id: "\\u591A\\u8FB9\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#0E1C39",
    cx: 99,
    cy: 296,
    r: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon_security.fd01240b3911fc8d7ab80049bf50749b.svg";
export { ForwardRef as ReactComponent };